
// discard
export const toLocaleLang = (lang) => {
	return lang==="zh-hk" ? "zh-HK" : "en-US";
}

export const getSiteCoreImagePath = (src, isLocalSrc = false) => {
    const url = window.globalConfig.VITE_SITECORE_IMAGE_URL || ''
	if(isLocalSrc){
		return `${src}`;
	}
	return src?.indexOf(url) === 0 ? src : `${url}${src}`;//${src?.indexOf('?')>=0 ? '&' : '?'}sc_lang=${toLocaleLang(lang)}`;
}

export const checkRedirectToOldWcip = (url = '/Loginform.aspx', lang) => {	
    if(window.globalConfig.VITE_REDIRECT_TO_OLD_WCIP){
		const searchParams = new URLSearchParams(santizeQueryString(window.location.search));
		searchParams.set('UIC', lang)
		// Rebuild safe query string
		const safeQS = santizeQueryString(searchParams.toString());
				
        let oldUrl = `${window.globalConfig.VITE_WCIP_URL}${url}?${safeQS}`;
		if(url.indexOf('Login/Webcast')>0){
			oldUrl = `${window.globalConfig.VITE_WEBCAST_URL}${url}`;
		}

        window.open(oldUrl, '_self');
		return null
    }
}

export const getLocationParamer = (key) => {
  const searchParams = new URLSearchParams(window.location.search);
  const lowerKey = key.toLowerCase();
  for (const [param, value] of searchParams.entries()) {
    if (param.toLowerCase() === lowerKey) {
        switch(value.toLowerCase()) {
            case 'threeinone':
                return "ThreeInOne";
            case 'hkjctv':
                return "HKJCTV";
            case 'racing':
                return "Racing";
            default:
                return value;
        }
    }
  }
  return null;
};

function isiPad() {
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    var isMacLike = navigator.userAgent.includes('Intel Mac OS X');
  
    return isTouchDevice && isMacLike;
}

export const getDeviceType = (width = 738) => {
    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform.toLowerCase();
  
    const isAndroid = /android/.test(userAgent) || /android|arm|aarch64/.test(platform);
    const isIOS = /iphone|ipad|ipod/.test(userAgent) || /iphone|ipad|ipod|macintel/.test(platform);
    const isTablet = /ipad|android(?!.*mobile)|tablet/.test(userAgent) || /ipad|tablet/.test(platform) || isiPad()
                        || isAndroid && (window.screen.width > width && window.screen.height > width);
    const isMobile = /iphone|ipod|android.*mobile/.test(userAgent) || /iphone|ipod|android/.test(platform);
    const isDesktop = !isMobile && !isTablet;
    
    if (window.globalConfig.deviceType) return window.globalConfig.deviceType; // testing

    return {
      isDesktop,
      isMobile,
      isTablet,
      isAndroid,
      isIOS
    };
  }
  export const getIsMobile = ()=>{
    const device = getDeviceType();
    return !device.isTablet && !device.isDesktop;
  }

  
export const isBoolean = (value)=>{
    return typeof value === 'boolean';
}

 export const loadFontFamily = (fontName) => {
    // 动态创建 link 标签
    const link = document.createElement('link');
    link.id = fontName;
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${fontName}:wght@100;200;300;400;500;600;700;800;900&display=swap`
    document.head.appendChild(link);
 }


export const groupBy = (collection, iteratee) => {
    // 处理空值情况
    if (!collection) return {};
    
    const result = {};
    const isFunction = typeof iteratee === 'function';
    const isString = typeof iteratee === 'string';
    
    // 处理数组和对象
    const values = Array.isArray(collection) 
        ? collection 
        : Object.values(collection);
    
    for (const item of values) {
        let key;
        
        if (isFunction) {
            // 如果是函数，使用函数返回值作为key
            key = iteratee(item);
        } else if (isString) {
            // 如果是字符串，使用对象属性值作为key
            key = item[iteratee];
        } else {
            // 其他情况直接使用值本身
            key = item;
        }
        
        // 确保key是字符串（作为对象属性）
        key = String(key);
        
        // 初始化分组数组（如果不存在）
        if (!result[key]) {
            result[key] = [];
        }
        
        // 将当前项添加到对应分组
        result[key].push(item);
    }
    
    return result;
}
   

export const fixJSON = (str) => {
    return str.replace(/(\w+):/g, '"$1":');
}
export const santizeQueryString = (queryString) => {
	const params = queryString.replace('?','').split('&').filter(Boolean).map(pair => {
		const [key, value = ''] = pair.split('=');
		// Sanitize the value to prevent XSS
		const sKey = key.split('').filter(char => char.charCodeAt(0) < 128).join('').replace(/[<>\"'&]/g, ''); // Remove non-ascii and HTML/JS dangerous chars
		const sValue = value.split('').filter(char => char.charCodeAt(0) < 128).join('').replace(/[<>\"'&]/g, ''); // Remove non-ascii and  HTML/JS dangerous chars
		return `${sKey}=${sValue}`;
	});

	// Rebuild safe query string
	return params.join('&');
}


export const addViewportMeta = (content) => {
    // 检查是否已存在 viewport meta
    const existingMeta = document.querySelector('meta[name="app-webview-title"]');
    
    if (!existingMeta) {
        const viewportMeta = document.createElement('meta');
        viewportMeta.name = 'app-webview-title';
        viewportMeta.content = content;
        document.head.appendChild(viewportMeta);
    } else {
        existingMeta.setAttribute('content', content)
    }
}
